import {Icon} from '@udemy-v2/icons';
import {useI18n} from '@udemy-v2/i18n';

import styles from './premium-course-notice.module.scss';

export const PremiumCourseNotice = () => {
    const {gettext} = useI18n();

    return (
        <div className={styles.container}>
            <Icon glyph="verified" size="xsmall" label={false} color="info" />
            <span className="ud-text-sm">
                {gettext('This Premium course is included in plans')}
            </span>
        </div>
    );
};
